import axios from 'axios';
import { API_BASE_URL } from '@/config/constants';
import { apiClient, getAccessToken } from './api';
import { isLocalAccessToken } from './localAuthTokens';
import type { AuthResult, CloudBaseUser, PasswordLoginCredentials, UpdateProfileData, ChangePasswordData } from './cloudbase/types';

export const isLocalSession = (): boolean => isLocalAccessToken(getAccessToken());

const localError = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const detail: unknown = error.response?.data?.detail;
    return new Error(typeof detail === 'string' ? detail : '账号服务暂时无法连接，请稍后重试');
  }
  return error instanceof Error ? error : new Error('操作失败，请稍后重试');
};

export const localAuth = {
  async loginWithPassword(credentials: PasswordLoginCredentials): Promise<AuthResult> {
    try {
      // Login uses a separate request: a wrong password must not trigger token refresh.
      const response = await axios.post(`${API_BASE_URL}/api/local-auth/login`, {
        account: credentials.account.trim(), password: credentials.password,
      }, { timeout: 15000 });
      return response.data.data;
    } catch (error) { throw localError(error); }
  },
  async getCurrentUser(): Promise<CloudBaseUser> {
    const response = await apiClient.get('/api/local-auth/me');
    return response.data.data;
  },
  async updateProfile(data: UpdateProfileData): Promise<CloudBaseUser> {
    const response = await apiClient.patch('/api/local-auth/profile', { nickName: data.nickName });
    return response.data.data;
  },
  async changePassword(data: ChangePasswordData): Promise<void> {
    await apiClient.post('/api/local-auth/change-password', data);
  },
  async logout(): Promise<void> {
    try {
      await axios.post(`${API_BASE_URL}/api/local-auth/logout`, {}, {
        headers: { Authorization: `Bearer ${getAccessToken()}` }, timeout: 15000,
      });
    } catch (error) { throw localError(error); }
  },
};

export const unsupportedLocalAccountAction = async (): Promise<never> => {
  throw new Error('演示账号使用账号密码登录，不支持此操作');
};
